import Helpers from '@/helpers';

export default {
	state: {
		discounts: [],
		othersDiscounts: [],
		selectedDiscounts: [],
		grossDiscount: [],
		totaToPay: 0,
		wantBook: false,
		courseCost: 0,
		bookCost: 0,
		selectedBookDiscount: null,
		selectedCourseDiscount: null,
		selectedAddtional: null
	},
	getters: {
		discounts: state => state.discounts,
		othersDiscounts: state => state.otherDiscounts,
		selectedDiscounts: state => state.selectedDiscounts,
		grossDiscount: state => state.grossDiscount,
		totaToPay: state => state.totaToPay,
		selectedBookDiscount: state => state.selectedBookDiscount,
		selectedCourseDiscount: state => state.selectedCourseDiscount,
		selectedAddtional: state => state.selectedAddtional,
	},
	mutations: {
		setDiscounts(state, discounts) {
			state.discounts = discounts
		},
		setOthersDiscounts(state, othersDiscounts) {
			state.othersDiscounts = othersDiscounts;
		},
		setWantBook(state, wantBook) {
			state.wantBook = wantBook;
		},
		setCourseCost(state, courseCost) {
			state.courseCost = courseCost;
		},
		setBookCost(state, bookCost) {
			state.bookCost = bookCost;
		},
		setTotalToPay(state, totaToPay) {
			state.totaToPay = totaToPay;
		},
		setDiscountsList(state, selectedDiscounts){
			state.selectedDiscounts = selectedDiscounts;
		},
		setDiscountsNuevo(state, grossDiscount){
			state.grossDiscount = grossDiscount;
		},
		setGrossDiscount(state) {
			let grossDiscount = 0;
			state.selectedBookDiscount = null;
			state.selectedCourseDiscount = null;

			state.selectedDiscounts.forEach(element => {
				let discount = Helpers.getDiscount(element, state.courseCost, state.bookCost);

				if(element.selected){		
					element.discount = Helpers.precise_round(discount,2);
					element.status = true;
					grossDiscount += Number(discount);
				
					if(element.item == 'DERECHOENSEÑANZA' && element.quotas_payment == 'AMBOS') {
						state.selectedCourseDiscount = element;
					}

					if(element.item == 'DERECHOENSEÑANZA' && element.quotas_payment == 'NO') {
						state.selectedAddtional = element;
					}

					if(element.item == 'LIBRO' && state.wantBook == 1) {
						state.selectedBookDiscount = element;
					}
				}
			});

			if(state.wantBook != 1){
				state.bookCost = 0;
			}
			
			state.grossDiscount = Helpers.precise_round(grossDiscount,2);
			state.totaToPay = Helpers.precise_round(Number(state.courseCost) + Number(state.bookCost) - grossDiscount,2);
		},
		setSelectedDiscounts(state) {

			state.selectedDiscounts = [];
			
			let discounts = Helpers.getDiscountsByType('DERECHOENSEÑANZA', state.discounts, state.othersDiscounts);
			let bookDiscounts = Helpers.getDiscountsByType('LIBRO', state.discounts, state.othersDiscounts);
			let selectedDiscounts = [];
			let majorCourseDicount = null;
			let parent = -1;

			for (let i = 0; i < discounts.length; i++) {
				discounts[i].status = true;

				if(discounts[i].discount_main){
					majorCourseDicount = discounts[i];
				} else if(discounts[i].quotas_payment != 'NO' && discounts[i].discount_type_apply != "NOACUMULABLE"){
					selectedDiscounts.push(discounts[i]);
				}
			}

			for (let j = 0; j < discounts.length; j++) {
				if(discounts[j].quotas_payment == 'AMBOS') {
					if(majorCourseDicount) {
						if(majorCourseDicount.percentage < discounts[j].percentage){
							majorCourseDicount = discounts[j];
							parent = discounts[j].other_discount_id;
						}
					} else {
						majorCourseDicount = discounts[j];
						parent = discounts[j].other_discount_id;
					}
				}
			}

			if(majorCourseDicount){
				majorCourseDicount.percentage_symbol = ' (' + majorCourseDicount.percentage + '%)';
				
				majorCourseDicount.selected = true;
				selectedDiscounts.push(majorCourseDicount);

				if(majorCourseDicount.other_discount_id){
					parent = majorCourseDicount.other_discount_id;
				}
			}

			selectedDiscounts.reverse((a,b) => {return b.selected && !a.selected}); 

			//pago cuota
			for (let a = 0; a < discounts.length; a++) {
				if(discounts[a].discount_type_apply == 'ACUMULABLE' && discounts[a].quotas_payment == 'NO'){
					discounts[a].percentage_symbol = ' (' + discounts[a].percentage + '%)';
					discounts[a].selected = true;
					selectedDiscounts.push(discounts[a]);
				}
			}

			//book discount
			for (let k = 0; k < bookDiscounts.length; k++) {
				if(bookDiscounts[k].parent_id != parent && state.wantBook == 1) {
					bookDiscounts[k].percentage_symbol = ' (' + bookDiscounts[k].percentage + '%)';
					bookDiscounts[k].selected = true;
					selectedDiscounts.push(bookDiscounts[k]);
				}
			}

			state.selectedDiscounts = selectedDiscounts;
		},
	},
	actions: {
		addDiscounts({ commit }, discounts) {
			commit('setDiscounts', discounts);
		},
		addOthersDiscounts({ commit }, othersDiscounts) {
			commit('setOthersDiscounts', othersDiscounts);
		},
		addWantBook({ commit }, wantBook) {
			commit('setWantBook', wantBook);
		},
		prepareDiscounts({commit}){
			commit('setSelectedDiscounts');
		},
		calculateGroosDiscount({commit}, prices) {
			commit('setCourseCost',prices.course);
			commit('setBookCost',prices.book);
			commit('setGrossDiscount');
		}
	}
}
